import { render, staticRenderFns } from "./HomeCard.vue?vue&type=template&id=3bd1b9bb&scoped=true&"
import script from "./HomeCard.vue?vue&type=script&lang=js&"
export * from "./HomeCard.vue?vue&type=script&lang=js&"
import style0 from "./HomeCard.vue?vue&type=style&index=0&id=3bd1b9bb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd1b9bb",
  null
  
)

export default component.exports